type ListFieldItem = {
  name?: unknown
}

/** Получает значение элемента списка, которое используется VSelect. */
const getListFieldItemValue = (item: unknown): unknown => {
  if (item && typeof item === 'object' && 'name' in item) {
    return (item as ListFieldItem).name
  }

  return item
}

/** Проверяет, что значение можно сопоставлять с элементами списка. */
const isFilledListValue = (value: unknown): boolean => value != null && value !== ''

/** Находит сохранённое значение среди доступных элементов списка. */
export const findAvailableListFieldValue = (rawValue: unknown, items: unknown[]): unknown => {
  if (!isFilledListValue(rawValue)) return undefined

  return items
    .map(getListFieldItemValue)
    .find((itemValue) => isFilledListValue(itemValue) && String(itemValue) === String(rawValue))
}

/** Возвращает значение для отображения, не показывая битые значения из модели. */
export const resolveListFieldDisplayValue = (
  rawValue: unknown,
  items: unknown[],
  multiple: boolean,
): unknown => {
  if (multiple) {
    const values = Array.isArray(rawValue) ? rawValue : []
    return values
      .map((itemValue) => findAvailableListFieldValue(itemValue, items))
      .filter(isFilledListValue)
  }

  return findAvailableListFieldValue(rawValue, items) ?? null
}
